import React, { useEffect, useState } from 'react';
import './ShippingMethod.css';
import CustomTextField from '../ShippingAddress/CustomTextField';
import CartService from '../../../services/CartService';
import { useSelector, useDispatch } from 'react-redux';
import { updateShippingAddress } from '../../../actions/actionCreators';


const DeliveryInstructionsPicker = (props) => {
  const cart = useSelector(state => state.cartReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const [editState, setEditState] = useState(() => !cart.shipping_address.note);

  //Handle click on edit address button, confirm & cancel button/ (Change local state)
  const toggleEditState = () => {
    setEditState(!editState);
  };

  const onCancel = () => {
    toggleEditState();
    props.collapsePicker(false);
    // let payload = [{ fieldToUpdate: 'note', value: '' }];
    // dispatch(updateShippingAddress(payload));
  }

  const dispatch = useDispatch();

  //Show autocomplete field when there's no address || editState = true (after btn click)  

  return (
    <div className='AddressPickerContainer'>
      <div>
        <CustomTextField
          fieldId={"delivery-instructions"}
          label={props.instructions}
          defaultValue={cart.shipping_address.note}
          onEditCallBack={editInstructions}
          onBlur={handleSubmit}
          containerStyle={{ width: '100%' }}
          optional={true}
        />
      </div>

    </div>
  )
    
  
  //Display prefilled address if there is an address & edit = false (default)


  function editInstructions(value) {
    let payload = [{ fieldToUpdate: 'note', value: value }];
    dispatch(updateShippingAddress(payload));

  }

  //Handle confirm/submit address
  async function handleSubmit() {
    let newAddress = getCompiledAddress();
    const addressUpdateResponse = await CartService.updateShippingAddress(newAddress, cart.token);
    toggleEditState();
  }

  function getCompiledAddress() {
    return {
      shipping_address: {
        first_name: cart.shipping_address.first_name,
        last_name: cart.shipping_address.last_name,
        phone: cart.shipping_address.phone,
        company: cart.shipping_address.company,
        note: cart.shipping_address.note,
        address1: cart.shipping_address.address1,
        address2: cart.shipping_address.address2,
        city: cart.shipping_address.city,
        country: cart.shipping_address.country,
        country_code: cart.shipping_address.country_code,
        province: cart.shipping_address.province,
        province_code: cart.shipping_address.province_code,
        zip: cart.shipping_address.zip,
      }
    }
  }

}

export default DeliveryInstructionsPicker;